import { render, staticRenderFns } from "./UserIP.vue?vue&type=template&id=d1e22480"
import script from "./UserIP.vue?vue&type=script&lang=js"
export * from "./UserIP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports